// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import audioReducer from './slices/audioSlice';
import uploadReducer from './slices/uploadSlice';
import courseReducer from './slices/coursesSlice';
import lessonReducer from './slices/lessonSlice';
import notesReducer from './slices/notesSlice';

export const store = configureStore({
    reducer: {
        user: userReducer,
        audio: audioReducer,
        upload: uploadReducer,
        course: courseReducer,
        lesson: lessonReducer,
        notes: notesReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
